import * as Switch from '@radix-ui/react-switch';
import clsx from 'clsx';

import s from './switch.module.css';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { getAsPath } from 'react-scale/lib/utils';

type Props = Pick<Switch.SwitchProps, 'checked' | 'onCheckedChange'>;

export const ViewSwitch = (props: Props) => {
  const router = useRouter();

  useEffect(() => {
    router.push(
      getAsPath(router.asPath, { viewMode: props.checked ? 'grid' : 'list' }),
      undefined,
      {
        scroll: false
      }
    );
  }, [props.checked]);

  return (
    <Switch.Root
      {...props}
      className={clsx(
        s['switch-container'],
        'group relative w-[98px] h-12 rounded-full bg-[#262626] hidden lg:block'
      )}
      id="view-mode"
      aria-label="View mode switch"
    >
      <Switch.Thumb
        className={clsx(
          s['switch-thumb'],
          'relative bg-white h-12 w-12 left-[3px] top-0 rounded-full'
        )}
      />
      <div className="w-full justify-around h-full absolute top-0 flex items-center z-20">
        <GridSVG className="group-data-[state=checked]:text-[#262626] relative -left-0.5 transition-colors duration-100" />
        <ListSVG className="group-data-[state=unchecked]:text-[#262626] relative left-0.5 transition-colors duration-100" />
      </div>
    </Switch.Root>
  );
};

const GridSVG = props => {
  return (
    <svg
      {...props}
      width="27"
      height="28"
      viewBox="0 0 27 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.0984 16.1996H15.3984V23.8996H23.0984V16.1996Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 16.1996H3.3V23.8996H11V16.1996Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.0984 4.09998H15.3984V11.8H23.0984V4.09998Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 4.09998H3.3V11.8H11V4.09998Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ListSVG = props => {
  return (
    <svg
      {...props}
      width="27"
      height="28"
      viewBox="0 0 27 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.79845 7.40002H23.0984"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.79845 14H23.0984"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.79845 20.6H23.0984"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.30001 7.40002H3.31126"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.30001 14H3.31126"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.30001 20.6H3.31126"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
